(function () {
  'use strict';

  /* =========================
     Carrier images (Shopify CDN)
     Fill in the "Copy link" URL from Content > Files for each carrier.
  ========================== */

  const CARRIER_IMAGES = {
    24: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/Colissimo_cc196d21-3f40-4368-9c56-86587285ac50.svg?v=1775203650', // Colissimo Corse
    30: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/mondial-logo.svg?v=1775200683', // Mondial relay
    58: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/Chrono.svg?v=1775203651', // Chrono Relais
    59: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/Chrono.svg?v=1775203651', // Chronopost à domicile
    66: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/rertait-magasin.svg?v=1786353948', // Retrait magasin NICE
    67: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/rertait-magasin.svg?v=1786353948', // Retrait magasin NICE
    253: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/dhl-logo.svg?v=1775200683', // DHL ECO
    277: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/dhl-logo.svg?v=1775200683', // DHL EXPRESS
    601: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/imx-logo.svg?v=1775200683', // IMX à domicile
    627: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/point-relais.svg?v=1786354025', // Livraison en point relais
    644: 'https://cdn.shopify.com/s/files/1/0992/1708/0660/files/Chrono.svg?v=1775203651' // Chronopost Europe
  };

  /* =========================
     Utils
  ========================== */

  function formatPrice(value) {
    if (value === 'Gratuit') return 'Gratuit';

    const num = parseFloat(value);
    if (isNaN(num)) return value;

    return 'Dès ' + num.toFixed(2) + '€';
  }

  /* =========================
     Countries <select>
  ========================== */

  function populateCountrySelect() {
    const select = document.getElementById('country');
    if (!select || !Array.isArray(window.shippingCountries)) return;

    select.innerHTML = '';
    let defaultCountryId = null;

    // 1️⃣ Tri global par "order"
    const sortedCountries = window.shippingCountries
      .slice()
      .sort((a, b) => (a.order || 0) - (b.order || 0));

    // 2️⃣ Regroupement par "group"
    const grouped = sortedCountries.reduce((acc, country) => {
      const group = country.group || 'Autres';
      if (!acc[group]) acc[group] = [];
      acc[group].push(country);
      return acc;
    }, {});

    // 3️⃣ Construction du <select>
    Object.entries(grouped).forEach(([group, countries]) => {
      const optgroup = document.createElement('optgroup');
      optgroup.label = group;

      countries.forEach(country => {
        if (!country.id || !country.label) return;

        const option = document.createElement('option');
        option.value = country.id;
        option.textContent = country.label;

        if (country.default === true) {
          defaultCountryId = country.id;
        }

        optgroup.appendChild(option);
      });

      if (optgroup.children.length > 0) {
        select.appendChild(optgroup);
      }
    });

    // 4️⃣ Sélection par défaut
    if (defaultCountryId) {
      select.value = defaultCountryId;
    }
  }

  /* =========================
     Shipping table
  ========================== */

  function renderTable(countryId) {
    const tbody = document.querySelector('#shipping-table tbody');
    if (!tbody) return;

    tbody.innerHTML = '';

    if (
      !window.shippingData ||
      !Array.isArray(window.shippingData[countryId])
    ) {
      return;
    }

    window.shippingData[countryId].forEach(row => {
      const tr = document.createElement('tr');

      /* Transporteur */
      const nameTd = document.createElement('td');
      const span = document.createElement('span');
      span.className = 'carrier-name';

      const imgSrc = CARRIER_IMAGES[row.id_reference];
      if (imgSrc) {
        const img = document.createElement('img');
        img.src = imgSrc;
        img.alt = row.name || '';
        img.width = 30;
        img.height = 30;
        img.style.marginRight = '8px';
        span.appendChild(img);
      }

      span.appendChild(document.createTextNode(row.name || ''));
      nameTd.appendChild(span);
      tr.appendChild(nameTd);

      /* Autres colonnes */
      const cells = [
        formatPrice(row.price),
        row.delay || '',
        row.delivery || '',
        row.free_shipping ? 'Dès ' + row.free_shipping + '€' : 'Non'
      ];

      cells.forEach(value => {
        const td = document.createElement('td');
        td.textContent = value;
        tr.appendChild(td);
      });

      tbody.appendChild(tr);
    });
  }

  /* =========================
     Init
  ========================== */

  function initCountrySelector() {
    const select = document.getElementById('country');
    if (!select) return;

    select.addEventListener('change', function () {
      renderTable(this.value);
    });

    if (select.value) {
      renderTable(select.value);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    populateCountrySelect();
    initCountrySelector();
  });
})();
